import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PhoneInput from 'src/components/form-components/PhoneInput/PhoneInput';
import TextInput, { TextInputType, createInputId } from 'src/components/form-components/TextInput/TextInput';
import ValidationMessage from 'src/components/form-components/ValidationMessage/ValidationMessage';
import { IUserBase } from 'src/entities/user';
import { IValidatable } from 'src/services/formValidator';
import globalMessages from 'src/services/globalMessages';
import { personalDetailsFields } from 'src/services/validations/userDetailsRules';

export interface IPersonalDetailsProps {
    autoFocus?: boolean;
    defaultUser: IUserBase;
    handleUserChange: (value: string, name: string) => void;
    isEmailRequired?: boolean;
    isPhoneNumberRequired?: boolean;
    isNameRequired?: boolean;
    adminCountryCode?: string;
}

export interface IPersonalDetails {
    reset: () => void;
}

const PersonalDetails = forwardRef<IPersonalDetails, IPersonalDetailsProps & IValidatable>((props, ref) => {

    const [phoneKey, setPhoneKey] = useState(0);

    useImperativeHandle(ref, () => ({
        reset: () => {
            setPhoneKey((key) => key + 1)
        }
    }));

    const { handleUserChange, validation, adminCountryCode, defaultUser } = props;
    const { Name, Email, Phone } = personalDetailsFields;

    const nameId = createInputId(Name);
    const emailId = createInputId(Email);

    return (
        <div className="personal-details-form">
            <TextInput
                autoFocus={props.autoFocus}
                className="personal-details-form__field"
                fieldName={Name}
                id={nameId}
                value={defaultUser.Name}
                label={globalMessages.name}
                onChange={handleTextInputChange}
                required={props.isNameRequired}
            />
            <ValidationMessage
                message={validation?.fields[Name]?.message}
                className="personal-details-form__validation"
            />

            <TextInput
                className="personal-details-form__field"
                id={emailId}
                fieldName={Email}
                value={defaultUser.Email}
                label={globalMessages.email}
                type={TextInputType.Email}
                onChange={handleTextInputChange}
                required={props.isEmailRequired}
            />
            <ValidationMessage
                className="personal-details-form__validation"
                message={validation?.fields[Email]?.message}
            />

            <PhoneInput
                key={phoneKey}
                className="personal-details-form__field"
                defaultValue={defaultUser.Phone}
                onChange={handlePhoneChange}
                required={props.isPhoneNumberRequired}
                adminCountryCode={adminCountryCode}
            />
            <ValidationMessage
                className="personal-details-form__validation"
                message={validation?.fields[Phone]?.message}
            />
        </div>
    )

    function handleTextInputChange(value: string, field: string) {
        handleUserChange(value, field);
    }

    function handlePhoneChange(value: string) {
        handleUserChange(value, 'Phone');
    }
});

export default PersonalDetails;
